import React, { useState, useEffect } from 'react'
import 'leaflet/dist/leaflet.css';
import './Nav.css'

const yellBatt = 40;

const BatteryImage = React.memo(({ battery }) => {
    const icon = battery < yellBatt
        ? '/image/modem/battery/e_batt.svg'
        : '/image/modem/battery/w_batt.svg';

    return (
        <img className='bat-box-icon' src={icon} />
    );
});

const getBatteryText = (battery) => {
    return battery < 0 ? 'nan' : `${battery}%`;
};

const Battery = React.memo(({ battery }) => {
    const textStyle = battery < yellBatt ? 'addition-yell' : 'addition-white';
    return (
        <div className={`bat-box-text ${textStyle}`}>
            {getBatteryText(battery)}
        </div>
    );
});

function BatteryBox({batterys}){
    return(
        <div className='tel-box bat-box'>
            {batterys == null ? 
            <div className='bat-ctn'>
                <div className='bat-box-text-container'>
                    <Battery battery={-1} />
                </div>
                <BatteryImage battery={-1} />
            </div> : 
            batterys?.battery.map(b => 
                <div className='bat-ctn'>
                    <div className='bat-box-text-container'>
                        <Battery battery={b.remaining} />
                    </div>
                    <BatteryImage battery={b.remaining} />
                </div>
            )
            
}
        </div>
    )
}

export default BatteryBox;
